import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
  constructor(private readonly translateService: TranslateService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    const language =
      this.translateService.currentLang ||
      this.translateService.defaultLang ||
      'en';

    const modifiedRequest = request.clone({
      headers: request.headers.set('x-language', language),
    });

    return next.handle(modifiedRequest);
  }
}
